var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_221_77321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.25 8.5004C16.25 4.22019 12.7802 0.7504 8.5 0.7504C4.21979 0.7504 0.75 4.22019 0.75 8.5004C0.75 12.3686 3.58406 15.5748 7.28906 16.1562V10.7406H5.32129V8.5004H7.28906V6.79298C7.28906 4.85063 8.44608 3.77774 10.2164 3.77774C11.0643 3.77774 11.9512 3.92911 11.9512 3.92911V5.83634H10.9739C10.0112 5.83634 9.71094 6.43374 9.71094 7.04662V8.5004H11.8604L11.5167 10.7406H9.71094V16.1562C13.4159 15.5748 16.25 12.3686 16.25 8.5004Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_221_77321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.5,
    height: 15.5,
    fill: "white",
    transform: "translate(0.75 0.750977)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.14d9db8a421b87fb8e2a29e278050746.svg";
export { ForwardRef as ReactComponent };